var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product && _vm.showRibbon)?_c('div',{staticClass:"ribbon-container",class:_vm.containerClass},[_c('div',{staticClass:"ribbon-wrapper"},[_c('nuxt-resource',{staticClass:"ribbon-image",attrs:{"lazy":"","aria-hidden":"true","src":_vm.ribbonImage,"alt":`${_vm.occasion} ribbon`}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }